module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('NoTopNavFooter'), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#ECECEC"
    },
    attrs: {
      "id": "login-background"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), (_vm.accessDenied) ? _c('div', {
    staticClass: "clogindiv",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(217, 57, 52)",
      "font-size": "14px",
      "padding": "20px 30px",
      "margin-top": "90px",
      "opacity": "0.95"
    }
  }, [(_vm.isMMApp) ? _c('div', [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "48px"
    }
  }, [_vm._v("400")]), _vm._v(" "), _c('div', {
    staticClass: "bad-request-title"
  }, [_vm._v("Bad Request")])]) : _vm._e(), _vm._v(" "), (!_vm.isMMApp) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v(" You are not assigned to this app in Okta.")])]) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "border-radius": "3px",
      "height": "45px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "float": "left",
      "height": "100%",
      "background": "rgb(217,57,52)",
      "color": "#fff",
      "padding": "7px 3px 10px 7px",
      "border-top-left-radius": "3px",
      "border-bottom-left-radius": "3px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    staticStyle: {
      "margin-right": "5px",
      "padding-top": "7px",
      "font-size": "16px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "error-title"
  }, [_vm._v("Access denied")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0fd90017", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fd90017"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Error.vue
// module id = 701
// module chunks = 1